/** @format */
import { css } from 'styled-components';

import { BasicPageHeaderProps } from './index';

/**
 * Base styles for the basic page header component
 *
 * @param {BasicPageHeaderProps} props The basic page header properties object
 * */
const baseStyles = (props: BasicPageHeaderProps) => css`
    text-align: center;
    border-bottom: 1px solid var(--colors-border-tertiary);
    padding-bottom: var(--layout-spacing-24);
    margin-bottom: var(--layout-spacing-48);
`;

/**
 * The basic page header component styles
 *
 * @param {BasicPageHeaderProps} props The basic page header properties object
 * */
export const styles = (props: BasicPageHeaderProps) => css`
    ${baseStyles(props)}
`;
